export default __webpack_public_path__ + "static/media/ic_text-italic.80d763d6.svg";